import JSONApiService from "@/services/JSONApiService";
import { USER_MODEL, USERS_TO_IMPERSONATE } from "@/models/user-model";
import { disablePluralizeForCall } from "@/services/utils";
import {
  ORGANISATION,
  ORGANISATIONS,
  ADDRESSES,
  CONTRACT_TYPES_GROUPINGS,
  WORKING_HOURS_GROUPINGS,
  include
} from "@/models/relationships";
import { EXPERIENCE_FUNCTION_MODEL } from "@/models/experience-function-model";
import { LOCATION_GROUPING_MODEL } from "@/models/location-grouping-model";
import { EXPERIENCE_MODEL } from "@/models/experience-model";
import { LANGUAGE_MODEL } from "@/models/language-model";
import { SKILL_MODEL } from "@/models/skill-model";
import { QUALIFICATION_MODEL } from "@/models/qualification-model";
import pluralize from "pluralize";

const authService = commit => ({
  me: async params => {
    const api = JSONApiService(commit);
    disablePluralizeForCall(api, () => {
      api.one(USER_MODEL, "self");
    });
    return api.get({
      ...include(
        ORGANISATION,
        ORGANISATIONS,
        ADDRESSES,
        pluralize(EXPERIENCE_FUNCTION_MODEL),
        pluralize(LOCATION_GROUPING_MODEL),
        pluralize(WORKING_HOURS_GROUPINGS),
        pluralize(CONTRACT_TYPES_GROUPINGS),
        pluralize(EXPERIENCE_MODEL),
        pluralize(LANGUAGE_MODEL),
        pluralize(SKILL_MODEL),
        pluralize(QUALIFICATION_MODEL)
      ),
      ...params
    });
  },
  update: async (id, editedUser) =>
    JSONApiService(commit).update(
      USER_MODEL,
      { id, ...editedUser },
      include(ORGANISATION, ORGANISATIONS)
    ),
  getUsersToImpersonate: async params => {
    const api = JSONApiService(commit);
    disablePluralizeForCall(api, () => {
      api.all(USERS_TO_IMPERSONATE);
    });
    return api.get({ params });
  }
});

export default authService;
